import type { FaireProductEntity } from "../../entity_types/product";

export const p_n5v7kmfym7: FaireProductEntity = {
  token: "p_n5v7kmfym7",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE SKY BLUE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/e35e3a2f447b2976a60ce9240d37ff375d433a0a6e9b0866bf580abc3086d240.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:09.734Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
